export default "__VITE_ASSET__DaW1V2$W__"